import React from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { Checkbox } from 'semantic-ui-react'
import classnames from 'classnames'

import CardControls from 'components/CardControls'
import CardInfo from 'components/CardInfo'
import CardTitle from 'components/CardTitle'
import DocPreview from 'components/DocPreview'
import LinkWithOverlay from 'components/LinkWithOverlay'
import Scaled from 'components/Scaled'

const DocCard = ({
  id,
  artboardCount,
  pageType,
  createdAt,
  updatedAt,
  docName,
  fontFamily,
  height,
  markup,
  menuLinks,
  overlayLink,
  ownerName,
  pageDimensions,
  scale,
  width,
  section,
  status,
  unviewed,
  isSelected,
  onSelectChange,
}) => {
  const createdAtDate = createdAt ? new Date(createdAt) : null
  const updatedAtDate = updatedAt ? new Date(updatedAt) : null
  const pageCount = markup['pageOrder'].length

  return (
    <div
      className={classnames({
        DocCard: true,
        'DocCard--selected': isSelected,
      })}
      style={{
        width: width,
      }}
      data-testid={`document-${id}`}
    >
      <div className="DocCard__header">
        <LinkWithOverlay
          ariaLabel={docName}
          href={overlayLink.href}
          overlayText={overlayLink.text}
        >
          <Scaled height={height} scale={scale} width={width}>
            <DocPreview fontFamily={fontFamily} markup={markup} zoom={scale} />
          </Scaled>
        </LinkWithOverlay>
      </div>

      <section className="DocCard__footer">
        <div className="DocCard__title">
          <CardTitle docName={docName} />
          <CardControls
            direction="left"
            menuIsUpward={false}
            menuLinks={menuLinks}
          />
        </div>

        <CardInfo
          pageType={pageType}
          createdAt={createdAtDate}
          updatedAt={updatedAtDate}
          ownerName={ownerName}
          pageCount={pageCount}
          pageDimensions={pageDimensions}
          artboardCount={artboardCount}
          section={section}
          status={status}
        />

        {onSelectChange && (
          <Checkbox
            className="DocCard__select"
            onChange={(_e, { checked }) => onSelectChange(id, !!checked)}
          />
        )}
      </section>

      {unviewed && <div className="DocCard__unviewed-badge" />}
    </div>
  )
}

DocCard.propTypes = exact({
  id: PropTypes.number.isRequired,
  artboardCount: PropTypes.number,
  pageType: PropTypes.string,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  docName: PropTypes.string.isRequired,
  fontFamily: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  markup: PropTypes.object.isRequired,
  menuLinks: PropTypes.arrayOf(PropTypes.object).isRequired,
  overlayLink: PropTypes.object.isRequired,
  ownerName: PropTypes.string.isRequired,
  pageDimensions: PropTypes.string.isRequired,
  scale: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  section: PropTypes.string,
  status: PropTypes.oneOf(['personal', 'published']).isRequired,
  unviewed: PropTypes.bool,
  isSelected: PropTypes.bool,
  onSelectChange: PropTypes.func,
})

export default DocCard
